import React from 'react';
import { Trustpilot as TrustpilotOD } from 'operation-diameter';

import styles from './ApplicationSidebar.module.css';

const ApplicationSidebar = () => (
  <div data-testid='application-sidebar' className={styles.applicationSidebar}>
    <TrustpilotOD additionalClassnames={styles.trustpilotBG} />
  </div>
);

export default ApplicationSidebar;
